<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.inviter_id"
        placeholder="邀请人ID"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.inviter_address"
        placeholder="邀请人地址"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
          v-model="listQuery.inviter_nickname"
          placeholder="邀请人昵称"
          style="width: 200px"
          class="filter-item"
          size="small"
          clearable
      />
      <el-input
          v-model="listQuery.be_inviter_id"
          placeholder="被邀请人ID"
          style="width: 200px"
          class="filter-item"
          size="small"
          clearable
      />
      <el-input
          v-model="listQuery.be_inviter_address"
          placeholder="被邀请人地址"
          style="width: 200px"
          class="filter-item"
          size="small"
          clearable
      />
      <el-input
          v-model="listQuery.be_inviter_nickname"
          placeholder="被邀请人昵称"
          style="width: 200px"
          class="filter-item"
          size="small"
          clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="邀请人ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="邀请人地址" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.inviter_user?scope.row.inviter_user.address:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="邀请人昵称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.inviter_user?scope.row.inviter_user.nickname:"-" }}
        </template>
      </el-table-column>

      <el-table-column label="被邀请人ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.be_invite_user_id }}
        </template>
      </el-table-column>
      <el-table-column label="被邀请人地址" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.be_invite_user?scope.row.be_invite_user.address:"-"  }}
        </template>
      </el-table-column>
      <el-table-column label="被邀请人昵称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.be_invite_user?scope.row.be_invite_user.nickname:"-" }}
        </template>
      </el-table-column>

      <el-table-column label="时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
      },
      dialogFormVisible: false,
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/user/invitation-logs",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-size: 18px;
  font-weight: bold;
}
</style>
